import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const diariesSearchSchema = z.object({
    organisationId: z.string().uuid().optional(),
    organisationName: z.string().optional(),
});

export const Route = createFileRoute("/_app/admin/sftp/diaries")({
    validateSearch: (search) => diariesSearchSchema.parse(search),
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/developer/sftp/diaries", search, replace: true });
    },
});
